var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle2, _path25, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 242,
    height: 242,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeWidth: 2,
    d: "M205.04 41.753v173.766h-18V41.753z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeWidth: 2,
    d: "M97.242 70.77h143.682V56.25H97.242z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "m205.024 41.753-17.97 14.48h17.97m0 159.286h-17.97l17.97-14.481h-17.97l17.97-14.48h-17.97l17.97-14.481h-17.97l17.97-14.48h-17.97l17.97-14.481h-17.97l17.97-14.48h-17.97l17.97-14.481h-17.97l17.97-14.48h-17.97l17.97-14.48M240.922 70.753V56.265l-17.961 14.488V56.265L205 70.753V56.265l-17.96 14.488V56.265l-17.961 14.488V56.265l-17.96 14.488V56.265l-17.961 14.488V56.265l-17.961 14.488V56.265l-17.96 14.488V56.265"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "m187.04 41.755 9-9.48 9 9.48zM97.24 56.25 83.357 70.77H97.24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M235.403 56.277c-1.152-.96-27.281-16.48-39.241-24.12l-78.483 24.12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3460",
    fillRule: "evenodd",
    d: "M166.281 70.747h38.762v24.12h-26.161l-12.601-12.6zm7.559 4.56h11.821v6.6H173.84zm15.958 0h11.82v6.6h-11.82z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3460",
    d: "M205.043 70.747h1l-1-1zm-38.762 0v-1l-1 1zm38.762 24.12v1l1-1zm-26.161 0-.707.708.707.293zm-12.601-12.6h-1l.293.708zm19.38-6.96h1l-1-1zm-11.821 0v-1l-1 1zm11.821 6.6v1l1-1zm-11.821 0h-1l1 1zm27.778-6.6h1l-1-1zm-11.82 0v-1l-1 1zm11.82 6.6v1l1-1zm-11.82 0h-1l1 1zm15.245-12.16h-38.762v2h38.762zm1 25.12v-24.12h-2v24.12zm-27.161 1h26.161v-2h-26.161zm-13.308-12.892 12.601 12.6 1.414-1.414-12.601-12.6zm-.293-12.228v11.52h2v-11.52zm20.38 3.56H173.84v2h11.821zm1 7.6v-6.6h-2v6.6zm-12.821 1h11.821v-2H173.84zm-1-7.6v6.6h2v-6.6zm28.778-1h-11.82v2h11.82zm1 7.6v-6.6h-2v6.6zm-12.82 1h11.82v-2h-11.82zm-1-7.6v6.6h2v-6.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F3460",
    strokeWidth: 2,
    d: "M97.237 70.8v26.162M91.839 102.357a5.4 5.4 0 1 0 5.4-5.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.24,
    cy: 89.455,
    r: 3.38,
    fill: "#1F3460",
    stroke: "#1F3460",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M177.423 219.043a4 4 0 0 1 4-4h29.921a4 4 0 0 1 4 4v1.76h-37.921z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3460",
    d: "M171.368 227.857a8 8 0 0 1 7.944-7.056h34.15a8 8 0 0 1 7.945 7.056l.601 5.064h-51.241z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M170.767 232.925h51.242v3.12h-51.242z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeWidth: 2,
    d: "M32.572 12.745v136.113h14.1V12.745z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeWidth: 2,
    d: "M117.014 35.468H4.466V24.094h112.548z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "m32.581 12.745 14.076 11.343H32.581m0 124.77h14.076l-14.076-11.342h14.076l-14.076-11.343h14.076L32.581 114.83h14.076l-14.076-11.343h14.076L32.581 92.144h14.076L32.581 80.803h14.076L32.581 69.459h14.076L32.581 58.116h14.076L32.581 46.773M4.464 35.457V24.108l14.069 11.35v-11.35L32.6 35.458v-11.35l14.07 11.35v-11.35l14.068 11.35v-11.35l14.069 11.35v-11.35l14.069 11.35v-11.35l14.068 11.35v-11.35l14.069 11.35v-11.35M46.672 12.745l-7.05-7.426-7.05 7.426zM117.014 24.094l10.875 11.374h-10.875z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M8.788 24.12c.902-.752 21.37-12.91 30.738-18.894l61.477 18.894"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    fillRule: "evenodd",
    d: "M62.935 35.452H32.573v18.894h20.492l9.87-9.87zm-5.92 3.573h-9.26v5.17h9.26zm-12.504 0h-9.26v5.17h9.26z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M32.573 35.452h-1l1-1zm30.362 0v-1l1 1zM32.573 54.346v1l-1-1zm20.492 0 .707.707-.707.293zm9.87-9.87h1l-.293.707zm-15.18-5.451h-1l1-1zm9.26 0v-1l1 1zm-9.26 5.17v1l-1-1zm9.26 0h1l-1 1zm-21.763-5.17h-1l1-1zm9.259 0v-1l1 1zm-9.26 5.17v1l-1-1zm9.26 0h1l-1 1zm-11.938-9.743h30.362v2H32.573zm-1 19.894V35.452h2v18.894zm21.492 1H32.573v-2h20.492zm10.577-10.163-9.87 9.87-1.414-1.414 9.87-9.87zm.293-9.73v9.023h-2v-9.024zm-16.18 2.572h9.26v2h-9.26zm-1 6.17v-5.17h2v5.17zm10.26 1h-9.26v-2h9.26zm1-6.17v5.17h-2v-5.17zm-22.763-1h9.259v2h-9.26zm-1 6.17v-5.17h2v5.17zm10.259 1h-9.26v-2h9.26zm1-6.17v5.17h-2v-5.17z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeWidth: 2,
    d: "M117.014 35.497V55.99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M54.202 152.485a4 4 0 0 0-4-4H28.497a4 4 0 0 0-4 4v.512h29.705z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M58.923 158.287a6 6 0 0 0-5.958-5.292H25.74a6 6 0 0 0-5.958 5.292l-.5 4.202h40.14z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M59.422 162.488H19.284v2.444h40.138z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    fillRule: "evenodd",
    d: "M156.252 212.21a2.64 2.64 0 0 0 2.643-2.64v-20.096H17.421v20.096a2.64 2.64 0 0 0 2.643 2.64z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    fillRule: "evenodd",
    d: "M13.947 186h148.421v23.571a6.114 6.114 0 0 1-6.116 6.113H20.064a6.115 6.115 0 0 1-6.117-6.113zm6.948 6.947v15.79H155.42v-15.79z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.421 113.052c0-.697.566-1.263 1.263-1.263h138.948c.697 0 1.263.566 1.263 1.263v80.211H17.421z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    fillRule: "evenodd",
    d: "M13.947 113.052a4.737 4.737 0 0 1 4.737-4.737h138.947a4.737 4.737 0 0 1 4.737 4.737v83.684H13.948zm6.948 2.211v74.526H155.42v-74.526z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    stroke: "#EDEDED",
    d: "M57.008 232.724a40.9 40.9 0 0 0 11.108-20.507h40.226a40.9 40.9 0 0 0 11.108 20.507l2.493 2.494H54.515z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.23,
    cy: 200.929,
    r: 4.138,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#706F6F",
    strokeWidth: 8,
    d: "M238.37 237.365H.921"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.832,
    height: 68.371,
    x: 26.091,
    y: 118.396,
    fill: "#50BCBD",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 58.819,
    y: 131.502,
    fill: "#EDF1FF",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 58.819,
    y: 151.031,
    fill: "#EDF1FF",
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 58.819,
    y: 170.561,
    fill: "#1F3460",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 89.342,
    y: 131.502,
    fill: "#1F3460",
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 89.342,
    y: 151.031,
    fill: "#50BCBD",
    rx: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 89.342,
    y: 170.561,
    fill: "#1F3460",
    rx: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 119.86,
    y: 131.502,
    fill: "#50BCBD",
    rx: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 87.371,
    height: 8.661,
    x: 59.066,
    y: 118.396,
    fill: "#EDF1FF",
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 119.86,
    y: 151.031,
    fill: "#1F3460",
    rx: 4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 26.576,
    height: 16.205,
    x: 119.86,
    y: 170.561,
    fill: "#50BCBD",
    rx: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9EA9BA",
    strokeWidth: 4,
    d: "m52.266 115.909 34.202-7.555a26 26 0 0 1 23.16 6.205l25.842 23.645"
  })));
};
export default SvgError;